import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Alert, Button, Modal } from '@opendate-app/setlist';

const axios = require('axios').default;

const MatchTemplateModal = ({ open, url, csrfToken, onClose, onMatched }) => {
  const [submitting, setSubmitting] = useState(false);
  const [refusal, setRefusal] = useState(null);
  const [refused, setRefused] = useState(false);

  const close = () => {
    setRefusal(null);
    setRefused(false);
    onClose();
  };

  const submit = async () => {
    setSubmitting(true);
    setRefusal(null);
    try {
      const response = await axios.post(url, {}, { headers: { 'X-CSRF-TOKEN': csrfToken } });
      setSubmitting(false);
      onMatched(response.data.seating_chart_event);
    } catch (error) {
      setSubmitting(false);
      setRefused(error.response?.status === 422);
      setRefusal(error.response?.data?.errors?.[0] || "Couldn't match this show to its template. Try again.");
    }
  };

  return (
    <Modal
      open={open}
      onClose={close}
      icon={false}
      title="Match template again"
      footer={(
        <>
          <Button onClick={close} disabled={submitting}>Cancel</Button>
          <Button variant="primary" onClick={submit} disabled={submitting || refused}>
            {submitting ? "Matching…" : "Match template"}
          </Button>
        </>
      )}
    >
      <p>This replaces this show&apos;s seat map with the current template. Your edits to this show&apos;s map will be lost.</p>
      {refusal && <Alert color="error" role="alert" title={refusal} />}
    </Modal>
  );
};

MatchTemplateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onMatched: PropTypes.func.isRequired,
};

export default MatchTemplateModal;
